import { ref, watch, toValue } from 'vue';

const logger = console;

/**
 * @param {string} folder - The assets subfolder
 * @param {Ref<string>|Function|string} theme - A ref, getter, or static string
 * @param {string} type - File extension
 */
export function useThemeBackground(folder, theme, type = 'jpg') {
  const backgroundImage = ref('');

  const getValidBackground = async (path, filename, fallbackFilename) => {
    const fullPath = `${path}${filename}`;
    const url = new URL(fullPath, window.location.origin).href;

    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) return url;
      logger.error(`Background image not found at ${url}`);
    } catch (error) {
      logger.error(`Error fetching background: ${error.message}`);
    }

    if (fallbackFilename) {
      return getValidBackground(path, fallbackFilename, null);
    }
    return '';
  };

  const updateBackground = async () => {
    // toValue unwrap refs or executes getters automatically
    const themeValue = toValue(theme) || 'default';
    const useDefaultImageFor = ['support'];

    const backgroundTheme = (useDefaultImageFor.includes(themeValue) ? 'default' : themeValue) || 'default';

    backgroundImage.value = await getValidBackground(
      `/assets/${folder}-backgrounds/`,
      `${backgroundTheme}.${type}`,
      `default.${type}`
    );
  };

  // Watch the input source. If it's a ref or getter, this triggers on change.
  // If it's a static string, it runs once and stops.
  watch(() => toValue(theme), updateBackground, { immediate: true });

  return {
    backgroundImage
  };
}